import * as types from "./actionTypes";

export const markDocumentReadThanetCouncil = (documentFilename) => ({
  type: types.MARK_DOCUMENT_READ_THANET_COUNCIL,
  payload: documentFilename,
});

export const setThanetCouncilReadingLoading = (isLoading) => {
  return {
    type: types.SET_THANET_COUNCIL_READING_LOADING,
    payload: isLoading,
  };
};

export const postRiskAssessmentThanetCouncil = (formName, formContent) => ({
  type: types.POST_RISK_ASSESSMENT_THANET_COUNCIL,
  payload: { formName, formContent },
});

export const setThanetCouncilRiskAssessmentLoading = (formName) => {
  return {
    type: types.SET_RISK_ASSESSMENT_LOADING_THANET_COUNCIL,
    payload: formName,
  };
};

export const postThanetCouncilForms = (formName, formContent) => ({
  type: types.POST_THANET_COUNCIL_FORMS,
  payload: { formName, formContent },
});

export const submitThanetCouncilForms = (formName, formContent, typeCode) => ({
  type: types.SUBMIT_THANET_COUNCIL_FORMS,
  payload: { formName, formContent, typeCode },
});
